import { render, staticRenderFns } from "./TucowsPromosExpiringInAWeek.vue?vue&type=template&id=e141f4de"
import script from "./TucowsPromosExpiringInAWeek.vue?vue&type=script&lang=js"
export * from "./TucowsPromosExpiringInAWeek.vue?vue&type=script&lang=js"
import style0 from "./TucowsPromosExpiringInAWeek.vue?vue&type=style&index=0&id=e141f4de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports